'use client';
import { createComponent } from '../core/create-component.js';
import { SWAN_STYLE_KEY_MAP } from '../head/stylesheets.component.js';

const propTypes = {};
const Table = createComponent({
    displayName: 'Table',
    root: 'table',
    propTypes,
    requiredStyleKeys: SWAN_STYLE_KEY_MAP.table,
    propConfig: {
        classNames: [
            'swan-table'
        ]
    }
});

export { Table };
